namespace $.$$ {
	$mol_style_define( $shm_hitalama_components_preview, {
		flex: { grow: 1, shrink: 0, basis: '24rem' },
		width: '24rem',
		maxWidth: '100%',
		Result: {
			flexDirection: 'column', minWidth: 0, maxWidth: '100%',
			margin: { bottom: $mol_gap.block },
			':empty': { margin: { bottom: 0 } },
		},
	})
}
